import PaymentLinkWrapper from "../components/PaymentLinkWrapper/PaymentLinkWrapper";

export default function PaymentLinkPage() {
    return <PaymentLinkWrapper />;
}
